import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Home from "../Home";
import { Tree, Select } from "antd";
import { Modal, Spinner } from "react-bootstrap";
import errorMessages from "../../common/errorMessages";
import { toast } from "react-toastify";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import "react-toastify/dist/ReactToastify.css";
import Breadcrumb from "../../components/Breadcrumb";
import Maintenance from "../Maintenance";
// import Tooltip from 'rc-tooltip';
// import { Tooltip as ReactTooltip } from "react-tooltip";
// import "./TerritoryDefinition.css";
import Tip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap.css";


import {
  fetchTerritoryBUList,
  fetchTerritoryDivisionList,
  fetchTerritoryBranchList,
  fetchTerritorySalesOfficeList,
  fetchTerritoryList,
  getTerritoryAllocationList,
  getTerritoryBlocksList,
  getBlocksbyTerritory,
  getFacilitiesList,
  saveTerritoryDefinition,
  applyBlocksFilter,
  restoreTerritory,
} from "./actions";

import {
  fetchUserRole,
} from "../OrganizationCustomer/actions";
// Dropdown
const options = [
  { value: "pption1", label: "Option 1" },
  { value: "pption2", label: "Option 2" },
  { value: "pption3", label: "Option 3" },
];
const options2 = [
  { value: "all", label: "All blocks" },
  { value: "unallocated", label: "Unallocated blocks" },
  {
    value: "newlyAddedUpdated",
    label: "Newly added/updated blocks (last 1 month)",
  },
];

const treeState = [
  {
    title: "Saitma Prefecture",
    key: "0-0",
    children: [
      { title: "Saitma Prefecture Child 1", key: "0-0-0" },
      { title: "Saitma Prefecture Child 2", key: "0-0-1" },
    ],
  },
  {
    title: "Tokyo Prefecture",
    key: "0-1",
    children: [
      { title: "Tokyo Prefecture Child 1", key: "0-1-0-0" },
      { title: "Tokyo Prefecture Child 2", key: "0-1-1-0" },
    ],
  },
  {
    title: "Kanagawa Prefecture",
    key: "0-2",
    children: [
      { title: "Tokyo Prefecture Child 1", key: "0-2-0-0" },
      { title: "Tokyo Prefecture Child 2", key: "0-1-1-0" },
    ],
  },
  {
    title: "State/Province1",
    key: "0-3",
    children: [
      { title: "State/Province1 Child 1", key: "0-3-0-0" },
      { title: "State/Province1 Child 2", key: "0-3-1-0" },
    ],
  },
  {
    title: "State/Province2",
    key: "0-4",
    children: [
      { title: "State/Province2 Child 1", key: "0-4-0-0" },
      { title: "State/Province2 Child 2", key: "0-4-1-0" },
    ],
  },
];
function TerritoryDefinition() {
  const [role, setRole] = useState("");
  const [buID, setBuID] = useState("");
  const [branchID, setBranchID] = useState("");
  const [divisionID, setDivisionID] = useState("");
  const [salesOfficeID, setSalesOfficeID] = useState("");
  const [territoryID, setTerritoryID] = useState("");
  const [buName, setBuName] = useState("");
  const [branchName, setBranchName] = useState("");
  const [divisionName, setDivisionName] = useState("");
  const [salesOfficeName, setSalesOfficeName] = useState("");
  const [territoryName, setTerritoryName] = useState("");
  const [showBlocksList, setShowBlocksList] = useState(false);
  const [blocksLoading, setBlocksLoading] = useState(false);
  const [duration, setDuration] = useState(0);
  const [toggleDuration, setToggleDuration] = useState(false);
  const [selectedTerritoryId, setSelectedTerritoryId] = useState("");
  const [applyToNext, setApplyToNext] = useState("");
  const [show, setShow] = useState(false);
  const [showRestoreModal, setshowRestoreModal] = useState(false);
  const [showRestore, setShowRestore] = useState(false);
  const [restoreSuccess, setRestoreSuccess] = useState(false);
  const [noData, setNoData] = useState(false);
  const [noFacilityData, setNoFacilityData] = useState(false);
  const [facilityLoading, setFacilityLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [errorBlockMessage, setErrorBlockMessage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [maintenance, setMaintenance] = useState(false);
  const [loading, setLoading] = useState();
  const [lazyLoading, setLazyLoading] = useState();
  const [resultLoading, setResultLoading] = useState();
  const [resultLoading1, setResultLoading1] = useState();
  const [filter, setFilter] = useState("");

  const [buLoading, setBULoading] = useState(false);
  const [divisionLoading, setDivisionLoading] = useState(false);
  const [branchLoading, setBranchLoading] = useState(false);
  const [salesOfficeLoading, setSalesOfficeLoading] = useState(false);
  const [territoryLoading, setTerritoryLoading] = useState(false);
  const [isChange, setIsChange] = useState(false);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(40);
  const [errors, setErrors] = useState({});
  const [token, setToken] = useState("");
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [previousCheckedKeys, setPreviousCheckedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [buList, setBuList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [divisionListDF, setDivisionListDF] = useState([]);
  const [branchListDF, setBranchListDF] = useState([]);
  const [facilitiesList, setFacilitiesList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [salesOfficeList, setSalesOfficeList] = useState([]);
  const [salesOfficeListDF, setSalesOfficeListDF] = useState([]);
  const [territoryList, setTerritoryList] = useState([]);
  const [territoryDefinitionList, setTerritoryDefinitionList] = useState([]);
  const [selectedTerritoryDefinitionList, setSelectedTerritoryDefinitionList] =
    useState([]);
  const [territoryBlocksList, setTerritoryBlocksList] = useState([]);
  const [blockNodes, setBlockNodes] = useState({});
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const [lang] = useTranslation("language");
  const [isActive, setIsActive] = useState("");
  const { DirectoryTree } = Tree;
  const [isBlocksSelectVisible, setIsBlocksSelectVisible] = useState(false);

  useEffect(() => {
    if(role==='SalesManager'){
      import('./TerritoryDefinition.css');
    }
  }, [role])
  
  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.territoryDefinition")}`,
      path: "",
    },
  ];

  const treeState = [
    {
      isLeaf: false,
      title: "",
      key: "0-0",
      children: [
        { title: "Saitma Prefecture Child 1", key: "0-0-0" },
        { title: "Saitma Prefecture Child 2", key: "0-0-1" },
      ],
    },
    {
      title: "Tokyo Prefecture",
      key: "0-1",
      children: [
        { title: "Tokyo Prefecture Child 1", key: "0-1-0-0" },
        { title: "Tokyo Prefecture Child 2", key: "0-1-1-0" },
      ],
    },
    {
      title: "Kanagawa Prefecture",
      key: "0-2",
      children: [
        { title: "Tokyo Prefecture Child 1", key: "0-2-0-0" },
        { title: "Tokyo Prefecture Child 2", key: "0-1-1-0" },
      ],
    },
    {
      title: "State/Province1",
      key: "0-3",
      children: [
        { title: "State/Province1 Child 1", key: "0-3-0-0" },
        { title: "State/Province1 Child 2", key: "0-3-1-0" },
      ],
    },
    {
      title: "State/Province2",
      key: "0-4",
      children: [
        { title: "State/Province2 Child 1", key: "0-4-0-0" },
        { title: "State/Province2 Child 2", key: "0-4-1-0" },
      ],
    },
  ];

  const [text, setText] = useState({})
  const [language, setLang] = useState({})

  useEffect(() => {
    if(sessionStorage.getItem("translation")){
      setText(JSON.parse(sessionStorage.getItem("translation")))
    }
    if(sessionStorage.getItem("translation")){
      setLang(sessionStorage.getItem("Language"))
    }
  }, [sessionStorage.getItem("Language")]);

  useEffect(() => {
    setTerritoryDefinitionList([]);
  }, [buID, divisionID, branchID, salesOfficeID, territoryID, duration]);

  useEffect(() => {
    const role = sessionStorage.getItem("User role");
    const bu = sessionStorage.getItem("BU");
    setRole(role);
    let cnt = duration == 1 ? 1 : 0;
    // if (role === "Admin" || role === "BusinessOperation") {
    // setDuration("1");
    // cnt = 1
    // } else {
    // cnt = 0
    // setDuration("0");
    // }
    setBuList(JSON.parse(bu));
    const buList = JSON.parse(bu)
    const buIDDefault = sessionStorage.getItem("buID");
    if (buIDDefault && buList && buList.length > 0) {
      const buDefault = buList.filter(item => item.value === buIDDefault)
      const createDevision = async (id) => {
        let cnt = duration == 1 ? 1 : 0;
        await fetchTerritoryDivisionList(id, cnt).then((res) => {
          setDivisionLoading(false);
          let list = [];
          for (let index = 0; index < res.length; index++) {
            const item = res[index];
            list.push({ value: item.divisionID, label: item.orgName });
          }
          setDivisionListDF(list);
        });
      }
      createDevision(buIDDefault)
      if (buDefault.length > 0) {
        setBuName(buDefault[0].label)
      }
      setBuID(buIDDefault);
    }
    let wwid = sessionStorage.getItem("WWID");
    !sessionStorage.getItem("Territory BU") && getTerritoryBUList(wwid, cnt);
    sessionStorage.setItem("return_url", "/territoryDefinition");
    if (sessionStorage.getItem("token")) {
      sessionStorage.setItem("return_url", "");
    }
  }, []);

  useEffect(() => {
    setBuID('')
    setBuName('');
    setDivisionID("");
    setDivisionName("");
    setBranchID("");
    setBranchName("");
    setSalesOfficeID("");
    setSalesOfficeName("");
    setTerritoryID("");
    setTerritoryName("");
    let wwid = sessionStorage.getItem("WWID");
    let cnt = duration == 1 ? 1 : 0;
    getTerritoryBUList(wwid, cnt);
  }, [duration, toggleDuration]);

  useEffect(() => {
    if (divisionListDF.length > 0) {
      const divisionIDDefault = sessionStorage.getItem("divisionID");
      const buIDDefault = sessionStorage.getItem("buID");
      if (divisionIDDefault && buIDDefault) {
        const createBranch = async (id1, id2) => {
          let cnt = duration == 1 ? 1 : 0;
          await fetchTerritoryBranchList({ buID: id1, divisionID: id2, currentMonth: cnt }).then(
            (res) => {
              setBranchLoading(false);
              let list = [];
              for (let index = 0; index < res.length; index++) {
                const item = res[index];
                list.push({ value: item.branchID, label: item.orgName });
              }
              setBranchListDF(list);
            }
          );
        }
        createBranch(buIDDefault, divisionIDDefault)
        const divDefault = divisionListDF.filter(item => item.value === divisionIDDefault)
        setDivisionID(divDefault[0].value)
        setDivisionName(divDefault[0].label)
      }
    }
  }, [divisionListDF]);

  useEffect(() => {
    if (branchListDF.length > 0) {
      const divisionIDDefault = sessionStorage.getItem("divisionID");
      const buIDDefault = sessionStorage.getItem("buID");
      const branchIdDefault = sessionStorage.getItem("branchId");
      if (branchIdDefault) {
        const branchDefault = branchListDF.filter(item => item.value === branchIdDefault)
        const createSales = async (id) => {
          await fetchTerritorySalesOfficeList({
            buID: buIDDefault,
            divisionID: divisionIDDefault,
            branchID: branchIdDefault,
            currentMonth: duration,
          }).then((res) => {
            setSalesOfficeLoading(false);
            let list = [];
            for (let index = 0; index < res.length; index++) {
              const item = res[index];
              list.push({ value: item.salesOfficeID, label: item.orgName });
            }
            setSalesOfficeListDF(list);
          });
        }
        createSales(branchDefault)
        if (branchDefault.length > 0) {
          setBranchID(branchDefault[0].value)
          setBranchName(branchDefault[0].label)
        }
      }
    }
  }, [branchListDF]);

  useEffect(() => {
    if (salesOfficeListDF.length > 0) {
      const salesOfficeIdDefault = sessionStorage.getItem("salesOfficeID");
      const divisionIDDefault = sessionStorage.getItem("divisionID");
      const buIDDefault = sessionStorage.getItem("buID");
      const branchIdDefault = sessionStorage.getItem("branchId");
      if (salesOfficeIdDefault) {
        const salesDefault = salesOfficeListDF.filter(item => item.value === salesOfficeIdDefault)
        const createTerritory = async (id) => {
          let cnt = duration == 1 ? 1 : 0;
          await fetchTerritoryList({
            buID: buIDDefault,
            divisionID: divisionIDDefault,
            branchID: branchIdDefault,
            salesOfficeID: salesOfficeIdDefault,
            currentMonth: cnt,
          }).then((res) => {
            setTerritoryLoading(false);
            let list = [];
            for (let index = 0; index < res.length; index++) {
              const item = res[index];
              list.push({ value: item.id, label: item.territory_set_name });
            }
            setTerritoryList(list);
          });
        }
        createTerritory(salesOfficeIdDefault)
        if (salesDefault.length > 0) {
          setSalesOfficeName(salesDefault[0].label)
          setSalesOfficeID(salesDefault[0].value)
        }
      }
    }
  }, [salesOfficeListDF]);


  /*** 
  @purpose : Get BU list
  @Parameter : {}
  **/
  const getTerritoryBUList = async (wwid, cnt) => {
    setBULoading(true);
    await fetchTerritoryBUList(wwid, cnt).then((res) => {
      if (res && res[0] && res[0].maintenanceWindowFlag) {
        setMaintenance(true)
      }
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({ value: item.buID, label: item.orgName });
      }
      setBuList(newList);
      setBULoading(false);
      sessionStorage.setItem("Territory BU", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Handle BU change
  @Parameter : {value}
  **/
  const handleBUChange = async (value) => {
    setDivisionID("");
    setDivisionName("");
    setBranchID("");
    setBranchName("");
    setSalesOfficeID("");
    setSalesOfficeName("");
    setTerritoryID("");
    setTerritoryName("");
    if (value) {
      setDivisionLoading(true);
      let data = value.label;
      setBuName(data);
      let id = value.value;
      setBuID(id);
      let cnt = duration == 1 ? 1 : 0;
      await fetchTerritoryDivisionList(id, cnt).then((res) => {
        setDivisionLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.divisionID, label: item.orgName });
        }
        setDivisionList(list);
      });
    } else if (value === "" || value === null) {
      setDivisionLoading(false);
      setBuID("");
      setBuName("");
      setDivisionID("");
      setDivisionName("");
      setBranchID("");
      setBranchName("");
      setSalesOfficeID("");
      setSalesOfficeName("");
      setTerritoryID("");
      setTerritoryName("");
    }
  };

  /*** 
  @purpose : Handle division change
  @Parameter : {value}
  **/
  const handleDivisionChange = async (value) => {
    setBranchID("");
    setBranchName("");
    setSalesOfficeID("");
    setSalesOfficeName("");
    setTerritoryID("");
    setTerritoryName("");
    if (value) {
      setBranchLoading(true);
      let data = value.label;
      setDivisionName(data);
      let id = value.value;
      setDivisionID(id);
      let cnt = duration == 1 ? 1 : 0;
      await fetchTerritoryBranchList({ buID: buID, divisionID: id, currentMonth: cnt }).then(
        (res) => {
          setBranchLoading(false);
          let list = [];
          for (let index = 0; index < res.length; index++) {
            const item = res[index];
            list.push({ value: item.branchID, label: item.orgName });
          }
          setBranchList(list);
        }
      );
    } else {
      setBranchLoading(false);
      setDivisionID("");
      setDivisionName("");
      setBranchID("");
      setBranchName("");
      setSalesOfficeID("");
      setSalesOfficeName("");
      setTerritoryID("");
      setTerritoryName("");
    }
  };

  /*** 
  @purpose : Handle branch change
  @Parameter : {}
  **/
  const handleBranchChange = async (value) => {
    setSalesOfficeID("");
    setSalesOfficeName("");
    setTerritoryID("");
    setTerritoryName("");
    if (value) {
      setSalesOfficeLoading(true);
      let data = value.label;
      setBranchName(data);
      let id = value.value;
      setBranchID(id);
      await fetchTerritorySalesOfficeList({
        buID: buID,
        divisionID: divisionID,
        branchID: id,
        currentMonth: duration,
      }).then((res) => {
        setSalesOfficeLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.salesOfficeID, label: item.orgName });
        }
        setSalesOfficeList(list);
      });
    } else {
      setSalesOfficeLoading(false);
      setBranchID("");
      setBranchName("");
      setSalesOfficeID("");
      setSalesOfficeName("");
      setTerritoryID("");
      setTerritoryName("");
    }
  };

  /*** 
  @purpose : Validate form
  @Parameter : {}
  **/
  const validateForm = () => {
    let isFormValid = true;
    let errors = {
      bu: "",
      division: "",
      branch: "",
      salesOffice: "",
      territory: "",
      duration: "",
    };

    if (buID === "") errors.bu = "errorMessages.PROVIDE_BU";
    else errors.bu = "";

    if (divisionID === "") errors.division = "errorMessages.PROVIDE_DIVISION";
    else errors.division = "";

    if (salesOfficeID === "")
      errors.salesOffice = "errorMessages.PROVIDE_SALES_OFFICE";
    else errors.salesOffice = "";

    if (branchID === "") errors.branch = "errorMessages.PROVIDE_BRANCH";
    else errors.branch = "";

    if (territoryID === "")
      errors.territory = "errorMessages.PROVIDE_TERRITORY";
    else errors.territory = "";

    if (duration === "") errors.duration = "errorMessages.PROVIDE_DURATION";
    else errors.duration = "";

    if (
      errors.bu !== "" ||
      errors.division !== "" ||
      errors.salesOffice !== "" ||
      errors.branch !== "" ||
      errors.territory !== "" ||
      errors.duration !== ""
    ) {
      isFormValid = false;
    } else {
      isFormValid = true;
    }

    setErrors(errors);
    return isFormValid;
  };

  /*** 
  @purpose : Handle territory definition
  @Parameter : {}
  **/
  const handleTerritoryDefinition = async () => {
    setFilter('all')
    setFacilitiesList([]);
    if (validateForm()) {
      setIsBlocksSelectVisible(false);
      setIsLoading(true);
      setLoading(true);
      setNoData(false);
      setShowBlocksList(false);
      setIsActive("");
      setTotal(0);
      setTerritoryDefinitionList([]);
      setTerritoryBlocksList([]);
      setFacilitiesList([]);
      setCheckedKeys([]);
      let cnt = duration == 1 ? 1 : 0;
      let nxt = duration == 1 ? 0 : 1;
      let nextMonth = duration === nxt
      let treePayload = {
        salesOfficeID: salesOfficeID,
        territorySetID: territoryID,
        filter: "all",
        // disableCheckbox: filter === "newlyAddedUpdated" ? true : false,objArray
        cnt: cnt,
        nextMonth: nextMonth,
      };
      setResultLoading(true);
      await getTerritoryBlocksList(treePayload).then((response) => {
        setResultLoading(false);
        // if (role === "SalesManager") {
        //   function addFlagRecursive(objArray) {
        //     const modifiedArray = [];
        //     for (let obj of objArray) {
        //       const modifiedObj = { ...obj };
        //       modifiedObj.disableCheckbox = true;
        //       if (modifiedObj.children && modifiedObj.children.length > 0) {
        //         modifiedObj.children = addFlagRecursive(modifiedObj.children);
        //       }
        //       modifiedArray.push(modifiedObj);
        //     }
        //     return modifiedArray;
        //   }
        //   setTerritoryBlocksList(addFlagRecursive(response.data));
        // } else {
          setTerritoryBlocksList(response.data);
        // }
      });
      let body = {
        salesOfficeID: salesOfficeID,
        territoryID: territoryID,
        currentMonth: duration,
        limit: 0,
        totalRecords: 0,
      };
      await getTerritoryAllocationList(body).then((res) => {
        if (res.maintenanceWindowFlag) {
          setMaintenance(true);
        } else {
          if (res.data.length === 0) {
            setIsLoading(false);
            setNoData(true);
            setLoading(false);
            setTerritoryDefinitionList([]);
            setTerritoryBlocksList([]);
          } else {
            setIsLoading(false);
            setNoData(false);
            setLoading(false);
            setTerritoryDefinitionList(res.data);
            setTotal(res.data[0].total);
          }
        }
      });
    }
  };

  const handleRestoreTerritory = async () => {
    setshowRestoreModal(false)
    if (selectedTerritoryId) {
      let cnt = duration == 1 ? 1 : 0;
      let treePayload = {
        territory_id: parseInt(selectedTerritoryId),
        cnt: cnt,
      };
      setIsLoading1(true)
      await restoreTerritory(treePayload).then((response) => {
        setIsLoading1(false)
        if (response.success === true && response.hasOwnProperty("error") === false) {
          setRestoreSuccess(true)
          modalShowRestore(true)
        } else {
          setRestoreSuccess(false)
          modalShowRestore(true)
        }
      });
      handleTerritoryDefinition();
    }
  };

  const handleRestoreTerritoryModal = () => {
    setshowRestoreModal(true)
  };

  // const handleContainerOnBottom = async () => {
  //   let body = {
  //     salesOfficeID: salesOfficeID,
  //     territoryID: territoryID,
  //     currentMonth: duration,
  //     limit: territoryDefinitionList.length,
  //     totalRecords: total,
  //   };
  //   if (territoryDefinitionList.length <= total && total >= 30) {
  //     await getTerritoryAllocationList(body).then((response) => {
  //       let list = [];
  //       list = territoryDefinitionList.concat(response.data);
  //       setTerritoryDefinitionList(list);
  //     });
  //     setLimit(limit + 10);
  //   }
  // };

  const loadRecords = async () => {
    let body = {
      salesOfficeID: salesOfficeID,
      territoryID: territoryID,
      currentMonth: duration,
      limit: territoryDefinitionList.length,
      totalRecords: total,
    };
    if (territoryDefinitionList.length < total) {
      setLazyLoading(true)
      await getTerritoryAllocationList(body).then((response) => {
        let list = [];
        list = territoryDefinitionList.concat(response.data);
        setLazyLoading(false)
        setTerritoryDefinitionList(list);
      });
      setLimit(limit + 10);
    }
  };

  // const containerRef = useBottomScrollListener(handleContainerOnBottom);

  /*** 
  @purpose : Handle sales office change
  @Parameter : {value}
  **/
  const handleSalesOfficeChange = async (value) => {
    setTerritoryID("");
    setTerritoryName("");
    if (value) {
      setTerritoryLoading(true);
      setSalesOfficeName(value.label);
      setSalesOfficeID(value.value);
      let cnt = duration == 1 ? 1 : 0;
      await fetchTerritoryList({
        buID: buID,
        divisionID: divisionID,
        branchID: branchID,
        salesOfficeID: value.value,
        currentMonth: cnt,
      }).then((res) => {
        setTerritoryLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.id, label: item.territory_set_name });
        }
        setTerritoryList(list);
      });
      // await getTerritoryBlocksList(value.value).then((res) => {
      //   setTerritoryBlocksList(res);
      // });
    } else {
      setTerritoryLoading(false);
      setSalesOfficeID("");
      setSalesOfficeName("");
      setTerritoryID("");
      setTerritoryName("");
    }
  };
  const handleClose = () => setShow(false);
  const handleCloseWarningRestore = () => setshowRestoreModal(false);
  const handleCloseRestore = () => setShowRestore(false);

  const modalShow = () => setShow(true);
  const modalShowRestore = () => setShowRestore(true);

  /*** 
  @purpose : Handle territory change
  @Parameter : {value}
  **/
  const handleTerritoryChange = (value) => {
    if (value) {
      setTerritoryID(value.value);
      setTerritoryName(value.label);
    } else {
      setTerritoryID("");
      setTerritoryName("");
    }
  };

  const onExpand = (expandedKeysValue) => {
    setExpandedKeys(expandedKeysValue);
    setAutoExpandParent(false);
  };

  const onCheck = (checkedKeysValue, info) => {
    if (filter === 'all') {
      setIsChange(true);
      setCheckedKeys(checkedKeysValue && checkedKeysValue);
      let checkedlist = [];
      let unCheckedlist = [];
      if (info) {
        if (info.checked) {
          info.checkedNodes &&
            info.checkedNodes.map((item) => {
              if (item.isLeaf === true) {
                checkedlist.push(item.block_id);
              }
            });
          setSelectedTerritoryDefinitionList(checkedlist);
        } else {
          info.checkedNodes &&
            info.checkedNodes.map((item) => {
              if (item.isLeaf === true) {
                unCheckedlist.push(item.block_id);
              }
            });
          let arr = [...previousCheckedKeys]
          const filteredArray = arr.filter(value => unCheckedlist.includes(value));
          setPreviousCheckedKeys(filteredArray)
          setSelectedTerritoryDefinitionList(unCheckedlist);
        }
      }
    } else {
      setIsChange(true);
      setCheckedKeys(checkedKeysValue && checkedKeysValue);
      let checkedlist = [];
      let unCheckedlist = [];
      if (info) {
        if (info.checked) {
          info.checkedNodes &&
            info.checkedNodes.map((item) => {
              if (item.isLeaf === true) {
                checkedlist.push(item.block_id);
              }
            });
          setSelectedTerritoryDefinitionList(checkedlist);
        } else {
          info.checkedNodes &&
            info.checkedNodes.map((item) => {
              if (item.isLeaf === true) {
                unCheckedlist.push(item.block_id);
              }
            });
          let arr = [...previousCheckedKeys]
          let filteredArray = []
          if (info.node.block_id) {
            filteredArray = arr.filter(value => value !== info.node.block_id);
          } else {
            function getBlockIds(obj) {
              let blockIds = [];
              if (obj.children && obj.children.length > 0) {
                for (let i = 0; i < obj.children.length; i++) {
                  blockIds = blockIds.concat(getBlockIds(obj.children[i]));
                }
              }
              if (obj.block_id) {
                blockIds.push(obj.block_id);
              }
              return blockIds;
            }
            let arr = [...previousCheckedKeys]
            const blockIds = getBlockIds(info.node);
            filteredArray = arr.filter(value => !blockIds.includes(value));
          }
          setPreviousCheckedKeys(filteredArray)
          setSelectedTerritoryDefinitionList(unCheckedlist);
        }
      }
    }
  };


  const onSelect = async (selectedKeysValue, info) => {
    if (info.node.block_id) {
      setFacilityLoading(true);
      setFacilitiesList([]);
      setSelectedKeys(selectedKeysValue);
      setNoFacilityData(false);
      await getFacilitiesList(info.node.block_id).then((res) => {
        if (res && res.length > 0) {
          setFacilityLoading(false);
          setFacilitiesList(res);
          setNoFacilityData(false);
        } else if (res.length <= 0) {
          setFacilityLoading(false);
          setNoFacilityData(true);
          setFacilitiesList([]);
        }
      });
    }
  };

  /*** 
  @purpose : Save Territory Allocation
  @Parameter : {}
  **/
  const handleApplyToNext = (e) => {
    setApplyToNext(e.target.checked);
  };

  /*** 
  @purpose : Handle duration change
  @Parameter : {}
  **/
  const handleDurationChange = async (e) => {
    setToggleDuration(!toggleDuration)
    setDuration(e.target.value);
    if (branchID) {
      await fetchTerritorySalesOfficeList({
        buID: buID,
        divisionID: divisionID,
        branchID: branchID,
        currentMonth: e.target.value,
      }).then((res) => {
        setSalesOfficeLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.salesOfficeID, label: item.orgName });
        }
        setSalesOfficeList(list);
      });
    }
    // setSalesOfficeID("");
    // setSalesOfficeName("");
    setTerritoryID("");
    setTerritoryName("");
  };

  const getBlocks = async (id) => {
    setIsBlocksSelectVisible(true);
    setBlocksLoading(true);
    setFacilitiesList([]);
    setSelectedKeys([]);
    setExpandedKeys([]);
    setNoFacilityData(false);
    setFacilityLoading(false);
    setIsActive(id);
    await getBlocksbyTerritory(id).then((response) => {
      setBlocksLoading(false);
      let list = [];
      response &&
        response.map((block) => {
          block.block_code && list.push(block.block_code);
        });
      let blocksList = [];
      response &&
        response.map((block) => {
          block.id && blocksList.push(block.id);
        });
      setCheckedKeys(list);
      setPreviousCheckedKeys(blocksList);
      setShowBlocksList(true);
    });
    setSelectedTerritoryId(id);
  };

  const saveTerritoryDefinitionList = async () => {
    setResultLoading(true);
    let cnt = duration == 1 ? 1 : 0;
    let nxt = duration == 1 ? 0 : 1;
    //Testing temporory fix for AHDD-5906 
    let finalArray = selectedTerritoryDefinitionList.concat(previousCheckedKeys);
    finalArray = finalArray.filter((item, index) => {
      return (finalArray.indexOf(item) == index)
    })
    let body = {
      params: { currentMonth: cnt, nextMonth: duration === nxt },
      data: {
        territoryDefinition: selectedTerritoryId,
        blocks: finalArray
        // blocks: isChange
        //   ? selectedTerritoryDefinitionList
        //   : previousCheckedKeys,
      },
    };
    let body1 = {
      params: { currentMonth: 1, nextMonth: 1 },
      data: {
        territoryDefinition: selectedTerritoryId,
        blocks: finalArray
        // blocks: isChange
        //   ? selectedTerritoryDefinitionList
        //   : previousCheckedKeys,
      },
    };
    const data = applyToNext ? body1 : body;
    let isSaveSuccessWithoutError = false;
    await saveTerritoryDefinition(data).then((response) => {
      if (
        response.success === true &&
        response.hasOwnProperty("error") === false
      ) {
        setResultLoading(false);
        isSaveSuccessWithoutError = true;
      } else if (
        response.success === true &&
        response.hasOwnProperty("error") === true
      ) {
        setResultLoading(false);
        setErrorMessage(true);
        setErrorBlockMessage(response.error);
      }
      setIsChange(false);
      setSelectedTerritoryDefinitionList([]);
      setPreviousCheckedKeys([]);
    });
    setBlocksLoading(true);
    let list = [];
    territoryDefinitionList.map((ter) => list.push(ter.id));
    let nextMonth = duration === nxt
    let payload = {
      salesOfficeID: salesOfficeID,
      territorySetID: territoryID,
      territoryDefinitionID: list,
      filter: filter,
      // disableCheckbox: filter === "newlyAddedUpdated" ? true : false,
      cnt: cnt,
      nextMonth: nextMonth,
    };
    await applyBlocksFilter(payload).then((res) => {
      // setBlocksLoading(false)
      setTerritoryBlocksList(res.data);
    });
    await getBlocksbyTerritory(selectedTerritoryId).then((response) => {
      setBlocksLoading(false);
      let list = [];
      response && response.map((block) => list.push(block.block_code));
      let blocksList = [];
      response &&
        response.map((block) => {
          block.id && blocksList.push(block.id);
        });
      setCheckedKeys(list);
      setPreviousCheckedKeys(blocksList);
      setShowBlocksList(true);
    });

    if (isSaveSuccessWithoutError) {
      modalShow();
    }
  };

  const handleTerritoryFilter = async (value) => {
    setFacilitiesList([]);
    setFilter(value.value);
    let list = [];
    territoryDefinitionList.map((ter) => list.push(ter.id));

    setBlocksLoading(true);
    if (value.value == "all" || value.value === "newlyAddedUpdated") {
      await getBlocksbyTerritory(selectedTerritoryId).then((response) => {
        setBlocksLoading(false);
        let list = [];
        response && response.map((block) => list.push(block.block_code));
        let blocksList = [];
        response &&
          response.map((block) => {
            block.id && blocksList.push(block.id);
          });
        setCheckedKeys(list);
        setPreviousCheckedKeys(blocksList);
        setShowBlocksList(true);
      });
    } else if (value.value === "unallocated") {
      setCheckedKeys([]);
    }
    let cnt = duration == 1 ? 1 : 0;
    let nxt = duration == 1 ? 0 : 1;
    let nextMonth = duration === nxt
    let body = {
      salesOfficeID: salesOfficeID,
      territorySetID: territoryID,
      territoryDefinitionID: list,
      filter: value.value,
      cnt: cnt,
      // disableCheckbox: filter === "newlyAddedUpdated" ? true : false,
      nextMonth: nextMonth,
    };
    setBlocksLoading(true);
    await applyBlocksFilter(body).then((res) => {
      setBlocksLoading(false);
      setTerritoryBlocksList(res.data);
    });
  };

  const handleCloseErrorMessage = () => setErrorMessage(false);
  const [finalText, setfinalText] = useState('')
  const [finalText2, setfinalText2] = useState("");
  useEffect(() => {
    const searchText = "territory";
    const filteredTexts = {};
    const filteredTexts2 = {};
    const searchText2 = "commonmessage";
    for (const key in text) {
      if (key.includes(searchText)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts[langKey] = value;
        }
      }
    }
    for (const key in text) {
      if (key.includes(searchText2)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts2[langKey] = value;
        }
      }
    }
    if(filteredTexts[language]){
      setfinalText(filteredTexts[language])
    }
    if (filteredTexts2[language]) {
      setfinalText2(filteredTexts2[language]);
    }

  }, [language,text]);
  

  return role === "Admin" || role === "SalesManager" ||
    role === "BusinessOperation" ? (
    <Home>
      {maintenance ? (
        <Maintenance />
      ) : (
        <>
          <Breadcrumb finalText2={finalText2} finalText={finalText} routes={routes} />
          <h2>{lang("Menu.territoryDefinition")}</h2>
          <div className="card" style={{ height: '1079px' }} >
            <div className="card-body">
              {/* {role === "MR" &&  */}
              {(role === "Admin" || role === "BusinessOperation") && (
                <div className="custom-radio d-inline-block">
                  <input
                    type="radio"
                    id="month1"
                    name="current-month"
                    value="1"
                    onChange={(e) => handleDurationChange(e)}
                  // checked={duration === "1" ? true : false}
                  />
                  <label htmlFor="month1">
                    {lang("territoryDefinitionMaintenance.currentMonth")}
                  </label>
                </div>
              )}
              <div className="custom-radio d-inline-block">
                <input
                  type="radio"
                  id="month2"
                  name="current-month"
                  value="0"
                  defaultChecked
                  onChange={(e) => handleDurationChange(e)}
                // checked={duration === "0" ? true : false}
                />
                <label htmlFor="month2">
                  {lang("territoryDefinitionMaintenance.nextMonth")}
                </label>
              </div>
              {/* {role !== "SalesManager" && <div className="custom-checkbox d-inline-block">
                <input
                  type="checkbox"
                  id="apply-month"
                  value={applyToNext}
                  onChange={(e) => handleApplyToNext(e)}
                  disabled={duration == 1 ? false : true}
                />
                <label htmlFor="apply-month">
                  {lang("territoryDefinitionMaintenance.applyToNext")}
                </label>
              </div>} */}
              {errors.duration && (
                <p className="error-text">{lang(`${errors.duration}`)}</p>
              )}
              <div className="row mt-3">
                <div className="col-xl-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      <span className="danger">*</span>
                      {lang("territoryDefinitionMaintenance.BU")}
                    </label>
                    <Select
                      className="ant-select"
                      options={buList}
                      onChange={handleBUChange}
                      allowClear={buID ? true : false}
                      value={{ value: buID, label: buName }}
                      loading={buLoading === true ? true : false}
                      showSearch={buList && buList.length > 0 ? true : false}
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    {errors.bu && (
                      <p className="error-text">{lang(`${errors.bu}`)}</p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      <span className="danger">*</span>
                      {lang("territoryDefinitionMaintenance.division")}
                    </label>
                    <Select
                      className="ant-select"
                      options={divisionList}
                      loading={divisionLoading}
                      onChange={handleDivisionChange}
                      allowClear={divisionID ? true : false}
                      disabled={buID ? false : true}
                      value={{ value: divisionID, label: divisionName }}
                      showSearch={
                        divisionList && divisionList.length > 0 ? true : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    {errors.division && (
                      <p className="error-text">{lang(`${errors.division}`)}</p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      <span className="danger">*</span>
                      {lang("territoryDefinitionMaintenance.branch")}
                    </label>
                    <Select
                      className="ant-select"
                      options={branchList}
                      onChange={handleBranchChange}
                      loading={branchLoading}
                      allowClear={branchID ? true : false}
                      disabled={divisionID ? false : true}
                      value={{ value: branchID, label: branchName }}
                      showSearch={
                        branchList && branchList.length > 0 ? true : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    {errors.branch && (
                      <p className="error-text">{lang(`${errors.branch}`)}</p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      <span className="danger">*</span>
                      {lang("territoryDefinitionMaintenance.salesOffice")}
                    </label>
                    <Select
                      className="ant-select"
                      options={salesOfficeList}
                      onChange={handleSalesOfficeChange}
                      allowClear={salesOfficeID ? true : false}
                      disabled={branchID ? false : true}
                      loading={salesOfficeLoading}
                      showSearch={
                        salesOfficeList && salesOfficeList.length > 0
                          ? true
                          : false
                      }
                      value={{ value: salesOfficeID, label: salesOfficeName }}
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    {errors.salesOffice && (
                      <p className="error-text">
                        {lang(`${errors.salesOffice}`)}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      <span className="danger">*</span>
                      {lang(
                        "territoryDefinitionMaintenance.territorySetToMaintain"
                      )}
                    </label>
                    <Select
                      className="ant-select"
                      options={territoryList}
                      onChange={handleTerritoryChange}
                      loading={territoryLoading}
                      allowClear={territoryID ? true : false}
                      disabled={salesOfficeID ? false : true}
                      showSearch={
                        territoryList && territoryList.length > 0 ? true : false
                      }
                      value={{ value: territoryID, label: territoryName }}
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                    {errors.territory && (
                      <p className="error-text">
                        {lang(`${errors.territory}`)}
                      </p>
                    )}
                  </div>
                </div>
                <div className="steps-action1 col-12">
                  {isLoading && <Spinner animation="border" />}
                  <button
                    className="btn btn-primary"
                    onClick={handleTerritoryDefinition}
                    disabled={isLoading}
                  >
                    {lang("Buttons.apply")}
                  </button>
                </div>
              </div>
              {territoryDefinitionList &&
                territoryDefinitionList.length > 0 &&
                loading === false && (
                  <div className="mt-5">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <p className="record-total">
                        {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
                        {territoryDefinitionList.length} / {total}
                      </p>
                      {selectedTerritoryId && <div style={{ display: "flex" }} >
                        <div style={{ display: "flex" }}>
                          <span className="ant-tree-checkbox ant-tree-checkbox-checked">
                            <span className="ant-tree-checkbox-inner"></span></span>
                          <span title="Partially Checked" style={{ marginTop: '4px', marginRight: '8px', marginLeft: '-12px' }} className="ant-tree-node-content-wrapper ant-tree-node-content-wrapper-close">{lang("territoryDefinitionMaintenance.checked")}</span>
                        </div>
                        <div style={{ display: "flex" }}>
                          <span className="ant-tree-checkbox ant-tree-checkbox-indeterminate">
                            <span className="ant-tree-checkbox-inner"></span></span>
                          <span title="Partially Checked" style={{ marginTop: '4px', marginRight: '8px', marginLeft: '-12px' }} className="ant-tree-node-content-wrapper ant-tree-node-content-wrapper-close">{lang("territoryDefinitionMaintenance.parChecked")}</span>
                        </div>
                        <div style={{ display: "flex" }}>
                          <span className="ant-tree-checkbox ant-tree-checkbox">
                            <span className="ant-tree-checkbox-inner"></span></span>
                          <span title="Partially Checked" style={{ marginTop: '4px', marginRight: '8px', marginLeft: '-12px' }} className="ant-tree-node-content-wrapper ant-tree-node-content-wrapper-close">{lang("territoryDefinitionMaintenance.unChecked")}</span>
                        </div>
                      </div>}
                    </div>
                    <div className="territory-boxes">
                      <div className="territory-column">
                        <div className="territory-head">
                          {lang(
                            "territoryDefinitionMaintenance.territoryDefinitions"
                          )}
                        </div>
                        <div
                          className="territory-body"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "inherit",
                            height: '633px',
                            justifyContent: "space-between"
                          }}
                        // ref={containerRef}
                        // onBottom={handleContainerOnBottom}
                        >
                          <ul className="select-terr">
                            {territoryDefinitionList.length > 0 &&
                              territoryDefinitionList.map((ter) => {
                                return (
                                  <>
                                    {/* <Tip
        placement="top"
        align={{ overflow: { adjustX: true, adjustY: true } }}
        overlay={
          <div
            style={{
              display: "inline-block",
              width: 'fit-width',
              height :'fit-width',
              padding: '6px',
              background: "white",
              opacity: 1
            }}
          >
            <div style={{ color: 'black', fontSize : '18px',fontWeight : '500' }} >{`${lang("territoryDefinitionMaintenance.updatedBy")} : ${ter.updated_by ? ter.updated_by : '' }`}</div>
            <div style={{ color: 'black', fontSize : '18px',fontWeight : '500' }}>{`${lang("territoryDefinitionMaintenance.lastUpdate")} : ${ter.last_updated_at ? ter.last_updated_at : '' }`}</div>
          </div>
        }
      > */}
                                    <li
                                      key={ter.id}
                                      // data-tip data-for="registerTip"
                                      onClick={() => getBlocks(ter.id)}
                                      className={
                                        isActive === ter.id ? "active" : ""
                                      }
                                    >
                                      {`${ter.territory_definition_name} :${ter.employee_ja_name}`}
                                      <br></br>
                                      <span
                                        className={
                                          isActive === ter.id ? "active" : "textColor"
                                        }
                                        style={{ fontSize: "0.68rem" }}
                                      >
                                        {`${lang(
                                          "territoryDefinitionMaintenance.updatedBy"
                                        )} : ${
                                          ter.updated_by ? ter.updated_by : `System`
                                        } `},
                                        {` ${lang(
                                          "territoryDefinitionMaintenance.lastUpdate"
                                        )} : ${
                                          ter.last_updated_at
                                            ? ter.last_updated_at
                                            : `System`
                                        }`}
                                      </span>
                                    </li>
                                    {/* </Tip> */}
                                    {/* <ReactTooltip effect="solid" place="right" id="registerTip">
                                  Tooltip for the register button1
                                  </ReactTooltip> */}
                                  </>
                                );
                              })}
                          </ul>
                          
                          {(role === "Admin" || role === "BusinessOperation") &&
                            <div className="steps-action1">
                              {isLoading1 && <Spinner animation="border" />}
                              <button
                                style={{
                                  width: "fit-content"
                                }}
                                className="btn btn-primary"
                                onClick={handleRestoreTerritoryModal}
                                disabled={!isActive}
                              >
                                {lang("Buttons.restore")}
                              </button>
                            </div>
                          }
                        </div>
                      </div>
                      <div className="territory-column">
                        <div className="territory-scroll">
                          <div className="territory-head">
                            {lang("territoryDefinitionMaintenance.blocks")}
                          </div>
                          <div className="territory-body" style={{
                            height: '633px',
                          }}>
                            {isBlocksSelectVisible && (
                              <Select
                                className="ant-select mb-3"
                                label="Single select"
                                options={options2}
                                disabled={blocksLoading}
                                onChange={handleTerritoryFilter}
                                defaultValue={{
                                  value: "all",
                                  label: "All blocks",
                                }}
                                labelInValue={true}
                                showSearch
                                optionFilterProp="label"
                              />
                            )}
                            {blocksLoading && <Spinner animation="border" />}
                            {showBlocksList && !blocksLoading && (
                              <>
                                <DirectoryTree
                                  checkable
                                  // disabled={role === "SalesManager"}
                                  onExpand={onExpand}
                                  expandedKeys={expandedKeys}
                                  autoExpandParent={autoExpandParent}
                                  onCheck={onCheck}
                                  checkedKeys={checkedKeys}
                                  showCheckbox={true}
                                  onSelect={onSelect}
                                  selectedKeys={selectedKeys}
                                  treeData={territoryBlocksList}
                                />
                                <div className="save-action mb-4">
                                  {resultLoading && (
                                    <Spinner animation="border" />
                                  )}
                                  <button
                                    className="btn btn-primary"
                                    disabled={
                                      // resultLoading === true ? true : false
                                      resultLoading || role === "SalesManager"
                                    }
                                    onClick={saveTerritoryDefinitionList}
                                  >
                                    {lang("Buttons.save")}
                                  </button>
                                  {role==='SalesManager' && <p style={{marginTop:'7px'}}>閲覧のみとなっております。</p>}
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="territory-column">
                        <div className="territory-head">
                          {lang(
                            "territoryDefinitionMaintenance.facilitiesInSelectedBlock"
                          )}
                        </div>
                        <div className="territory-body" style={{
                          height: '633px',
                        }}>
                          {facilityLoading && <Spinner animation="border" />}
                          {noFacilityData === false && (
                            <ul className="select-terr terr-normal">
                              {facilitiesList &&
                                facilitiesList.map((fac,index) => {
                                  return <li key={index}>{`${fac.customerCode} ${fac.facilityName}`}</li>;
                                })}
                            </ul>
                          )}
                          {noFacilityData === true && (
                            <p className="noData">No facilities found !!</p>
                          )}
                        </div>
                      </div>
                    </div>

                    {total !== territoryDefinitionList.length && (
                      <div className="steps-action1 mt-4">
                        {lazyLoading && <Spinner animation="border" />}
                        <button
                          className="btn btn-primary"
                          onClick={loadRecords}
                          disabled={lazyLoading}
                        >
                          {lang("Buttons.loadMore")}
                        </button>
                      </div>
                    )}
                    <Modal
                      size="sm"
                      className="withdraw-modal"
                      show={show}
                      onHide={handleClose}
                      aria-labelledby="contained-modal-title-vcenter"
                      centered
                    >
                      <Modal.Body>
                        <div className="warning-msg">
                          {lang("errorMessages.SAVE_SUCCESS")}
                        </div>
                        <div className="buttons-group">
                          <button
                            className="btn btn-primary"
                            onClick={handleClose}
                          >
                            {lang("Buttons.ok")}
                          </button>
                        </div>
                      </Modal.Body>
                    </Modal>
                    <Modal
                      size="sm"
                      className="withdraw-modal"
                      show={showRestoreModal}
                      onHide={handleCloseWarningRestore}
                      aria-labelledby="contained-modal-title-vcenter"
                      centered
                    >
                      <Modal.Body>
                        <div className="warning-msg">
                          {lang("errorMessages.WARNING_RESTORE")}
                        </div>
                        <div className="buttons-group">
                          <button className="btn btn-primary" onClick={handleRestoreTerritory}>
                            {lang("Buttons.ok")}
                          </button>
                          <button className="btn btn-primary" onClick={handleCloseWarningRestore}>
                            {lang("Buttons.cancel")}
                          </button>
                        </div>
                      </Modal.Body>
                    </Modal>
                    <Modal
                      size="sm"
                      className="withdraw-modal"
                      show={showRestore}
                      onHide={handleCloseRestore}
                      aria-labelledby="contained-modal-title-vcenter"
                      centered
                    >
                      <Modal.Body>
                        <div className="warning-msg">
                          {restoreSuccess ? lang("errorMessages.RESTORE_SUCCESS") : lang("errorMessages.RESTORE_FAILED")}
                        </div>
                        <div className="buttons-group">
                          <button
                            className="btn btn-primary"
                            onClick={handleCloseRestore}
                          >
                            {lang("Buttons.ok")}
                          </button>
                          {/* <button className="btn btn-primary" onClick={handleClose}>{lang("Buttons.cancel")}</button> */}
                        </div>
                      </Modal.Body>
                    </Modal>
                  </div>
                )}
              {territoryDefinitionList.length === 0 && loading === true && (
                <Spinner animation="border" />
              )}
              {noData && (
                <div className="noData">{lang("errorMessages.NO_DATA")}</div>
              )}
            </div>
            <Modal
              size="md"
              className="withdraw-modal"
              show={errorMessage}
              onHide={handleCloseErrorMessage}
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Body>
                <div className="warning-msg territory-error">
                  <img src="images/warning2.svg" alt="Warning" />
                  <p>{errorBlockMessage}</p>
                </div>
                <div className="buttons-group">
                  <button
                    className="btn btn-primary"
                    onClick={handleCloseErrorMessage}
                  >
                    {lang("Buttons.ok")}
                  </button>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </>
      )}
    </Home>
  ) : (
    <Home>
      <p>You don't have required permission to view this page</p>
    </Home>
  );
}

export default TerritoryDefinition;
